export const delayPromise = <T>(
  promise: () => Promise<T>,
  ms: number
): Promise<T> =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      promise().then(resolve).catch(reject);
    }, ms);
  });
